import React, { useEffect, useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";

function Messages() {
    const messageEventId = "333";

    const [processing, setProcessing]                                   = useState(false);
    
    const [listMessages, setListMessages]                               = useState([]);
    const [eventMessages, setEventMessages]                             = useState([]);

    const anniId                                = "682026ec47b0e1cbe62b4c79";

      useEffect(() => {
        if (eventMessages.length > 0) {
            setProcessing(true);
                fetch(`https://lovedripp-api.onrender.com/api/annivites/messages/migration/`, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ "id": anniId, "eventMessages" : eventMessages }),
                })
                .then(res => res.json())
                    .then(data => {
                    console.log('Messages posted:', data);
                    setProcessing(false);
                    })
                .catch(err => {
                    console.error('Error posting messages:', err);
                    setProcessing(false);
                    });
        }
    }, [eventMessages]);

        
    const handleListingMessages = async () => {
        try{
              
          setProcessing(true);
          const response = await axios.get(CONSTANTS.MIGRATION_DOMAIN +"messages-list/onvite/" + messageEventId);
               
          console.log(response.data);
          setListMessages(response.data);
          setProcessing(false);
          
        }catch(errorData){
          setProcessing(false);
          console.log(errorData);
          if(errorData.status === 404){
            alert(errorData.response.data.message);
          }
        }
    }

    const handleTransferToMain = () => {
        try{

            const transformed = listMessages.map(item => ({
                name: item.name,
                email: item.email,
                message: item.message,
                rsvp: item.going === "YES",
                visible: item.approve === "0"
            }));

            console.log(transformed);
            setEventMessages(transformed);
        }catch(err){
            console.log(err);
        }
    }
    
  return (
    <div>
        <h1>{messageEventId}</h1>
        <button
            className="btn btn-info"
            onClick={() => handleListingMessages()}
            disabled={processing}
            >
            Show More
        </button>
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <h2>Messages</h2>
                    {
                        listMessages &&
                        listMessages.length > 0 && (
                            <ul>
                              {
                                listMessages.map((message, index) => {
                                    return <li className="card" key={index}> 
                                                <div className="card-box">
                                                    {message.name}
                                                    <p>{message.message}</p>
                                                </div>                                                
                                            </li>
                                })
                              }
                            </ul>
                        )
                    }
                </div>
                <div className="col-md-6">
                    {
                        listMessages &&
                        listMessages.length > 0 && (
                            <div className="migrate-mess">
                                <h2>Migrate Now</h2>
                                <div className="mig-block">
                                    <button
                                        className="btn"
                                        onClick={() => handleTransferToMain()}
                                        >
                                        Transfer Blocks
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
        {
            processing && (
                <div className="processing-spinner">
                        <img src={CONSTANTS.SMALL_PROCESSING} className="pro-spin" />
                </div>
            )
        
        }
    </div>
  )
}

export default Messages